export const campDetails = {
  title: "Mega Blood Donation Camp",
  date: "06-08-2026",
  subtitle: "Bhavan Wise Coordinators List",
  venueMonitors: [
    { name: "Mr. P. Siva kumar", phone: "99596 73692", rowSpan: 8 },
    { name: "Dr. I.V.Veeranjaneyulu", phone: "7729990278", rowSpan: 7 }
  ],
  coordinators: [
    {
      sNo: 1,
      organization: "GGH, Rampachodavaram",
      venue: "Cotton Bhavan, Seminar Hall",
      roomNo: "208",
      coordinator: "Mr. K Sai Kishore",
      designation: "Extension Activity, Member",
      phone: "9133691984",
      doctorName: "Dr. M. Spandana",
      doctorPhone: "9493280431",
      monitor: "Mr. P. Siva kumar",
      monitorPhone: "99596 73692"
    },
    {
      sNo: 2,
      organization: "Rotary Blood Bank, KKD",
      venue: "K.L. Rao Bhavan, Seminar Hall",
      roomNo: "101",
      coordinator: "Mr. S.Ganapathi",
      designation: "Program Officer, NSS Unit-2",
      phone: "9032201091",
      doctorName: "Dr. Kamaraju",
      doctorPhone: "9848620802",
      monitor: "Mr. P. Siva kumar",
      monitorPhone: "99596 73692"
    },
    {
      sNo: 3,
      organization: "Dr. YSR Jakkampudi Rammohan Rao Blood Center, RJY",
      venue: "Bill Gates Bhavan, Seminar Hall",
      roomNo: "101",
      coordinator: "Mrs Bh. Hema Nagamni",
      designation: "Program Officer, NSS Unit-7",
      phone: "7981012226",
      doctorName: "Dr. Jakkampudi Rajasree",
      doctorPhone: "8330982887",
      monitor: "Mr. P. Siva kumar",
      monitorPhone: "99596 73692"
    },
    {
      sNo: 4,
      organization: "Sidhartha Blood Bank, KKD",
      venue: "Bill Gates Bhavan, Seminar Hall",
      roomNo: "201",
      coordinator: "Ms. P.Lakshmi / Dr.G.Venkata Pavan Kumar",
      designation: "Coordinator, Eco-Club / Program Officer, NSS Unit-3",
      phone: "7702716589 / 9949290928",
      doctorName: "Dr. P. Govindharajulu",
      doctorPhone: "9848229897",
      monitor: "Mr. P. Siva kumar",
      monitorPhone: "99596 73692"
    },
    {
      sNo: 5,
      organization: "Vijaya Sri Blood Bank, RJY",
      venue: "Visweswarya Bhavan, Seminar Hall",
      roomNo: "010",
      coordinator: "Dr.M.Raghunath",
      designation: "Asst Professor, ECE",
      phone: "9640626333",
      doctorName: "Dr.K Gopala Krishna",
      doctorPhone: "94928 35899",
      monitor: "Mr. P. Siva kumar",
      monitorPhone: "99596 73692"
    },
    {
      sNo: 6,
      organization: "Sri Yuva Sena Blood Bank, KKD",
      venue: "Visweswarya Bhavan, Seminar Hall",
      roomNo: "008",
      coordinator: "Dr. Vijay Kumar",
      designation: "Program Officer, NSS Unit-4",
      phone: "9391297597",
      doctorName: "Mr. T. Vamsi",
      doctorPhone: "9700937840",
      monitor: "Mr. P. Siva kumar",
      monitorPhone: "99596 73692"
    },
    {
      sNo: 7,
      organization: "Akashaya Blood Bank, KKD",
      venue: "Bhaskar Bhavan, Seminar Hall",
      roomNo: "001",
      coordinator: "Ms. P.V.B Annapurna",
      designation: "Coordinator, LEO- Club",
      phone: "7981157620",
      doctorName: "Dr. Rammurthy",
      doctorPhone: "9003546777",
      monitor: "Mr. P. Siva kumar",
      monitorPhone: "99596 73692"
    },
    {
      sNo: 8,
      organization: "Satya Surya Blood Bank, RJY",
      venue: "Bhaskar Bhavan, Seminar Hall",
      roomNo: "323",
      coordinator: "Mr. D. Satyanarayana",
      designation: "Program Officer, NSS Unit-6",
      phone: "9182389089",
      doctorName: "Dr.P Nalini Mohan",
      doctorPhone: "9849520969",
      monitor: "Mr. P. Siva kumar",
      monitorPhone: "99596 73692"
    },
    {
      sNo: 9,
      organization: "GGH, Kakinada",
      venue: "C.V. Raman Bhavan, Seminar Hall",
      roomNo: "101",
      coordinator: "Mr. Ch.Ramprasa",
      designation: "Program Officer, NSS Unit-1",
      phone: "8885841223",
      doctorName: "Dr.B S V S Rashmitha",
      doctorPhone: "9493232333",
      monitor: "Dr. I.V.Veeranjaneyulu",
      monitorPhone: "7729990278"
    },
    {
      sNo: 10,
      organization: "Sahasra Blood Bank, AMP",
      venue: "Ramanujan Bhavan, Seminar Hall",
      roomNo: "005",
      coordinator: "Mrs Jyothula Vidya",
      designation: "Program Officer, NSS Unit-5",
      phone: "8143857336",
      doctorName: "Dr. Srinivas Sir",
      doctorPhone: "9491965625",
      monitor: "Dr. I.V.Veeranjaneyulu",
      monitorPhone: "7729990278"
    },
    {
      sNo: 11,
      organization: "ASN Raju Charitable Trust, Blood Bank, BVRM",
      venue: "Ramanujan Bhavan, Seminar Hall",
      roomNo: "101",
      coordinator: "Mr.B.K. Vidyasagar",
      designation: "Program Officer, NSS Unit-9",
      phone: "9959741857",
      doctorName: "Dr.Durga Prasad",
      doctorPhone: "9666001234",
      monitor: "Dr. I.V.Veeranjaneyulu",
      monitorPhone: "7729990278"
    },
    {
      sNo: 12,
      organization: "GGH, Rajamahendravaram",
      venue: "Newton Bhavan, Seminar Hall",
      roomNo: "201",
      coordinator: "Mr. B.Gowtham Singh",
      designation: "Extension Activity, Member",
      phone: "7032725855",
      doctorName: "Dr. Naseeruddin",
      doctorPhone: "7680036834",
      monitor: "Dr. I.V.Veeranjaneyulu",
      monitorPhone: "7729990278"
    },
    {
      sNo: 13,
      organization: "Indian Red Cross Blood Bank, KKD",
      venue: "James Watt, Seminar Hall",
      roomNo: "308",
      coordinator: "Mr. V.V. Srimanarayana",
      designation: "Coordinator, Rotaract- Club",
      phone: "9000966106",
      doctorName: "Dr.Durga Raju",
      doctorPhone: "9848424389",
      monitor: "Dr. I.V.Veeranjaneyulu",
      monitorPhone: "7729990278"
    },
    {
      sNo: 14,
      organization: "Rotary Blood Bank, PDP",
      venue: "Abdul Kalam Bhavan, Seminar Hall",
      roomNo: "006",
      coordinator: "Mr.G.Manikanta",
      designation: "Sr.Lecturer, DME",
      phone: "9000604053",
      doctorName: "Dr. Sree Ramakrishna Chowdary",
      doctorPhone: "9440224757",
      monitor: "Dr. I.V.Veeranjaneyulu",
      monitorPhone: "7729990278"
    },
    {
      sNo: 15,
      organization: "Dhanvantari Blood Bank, RJY",
      venue: "School of Business, Seminar Hall",
      roomNo: "004",
      coordinator: "Dr.S.R. Lakshmi Devarakonda",
      designation: "Program Officer, NSS Unit-8",
      phone: "9491520487",
      doctorName: "Mr. Ch. Srinivas",
      doctorPhone: "9885186533",
      monitor: "Dr. I.V.Veeranjaneyulu",
      monitorPhone: "7729990278"
    }
  ]
};
